class ProductTabs extends HTMLElement {
    constructor() {
        super();
        this.tabs = this.querySelectorAll('product-tab');
        this.contents = this.querySelectorAll('product-tabcontent');

        this.tabs.forEach((tab) => {
            tab.addEventListener('click', this.onTabClick.bind(this));
        });
        if (this.tabs.length > 0) {
            this.tabs[0].classList.add('--active');
        }
        if (this.contents.length > 0) {
            this.contents[0].classList.add('--active');
        }
    }

    onTabClick(event) {
        event.preventDefault();
        if (event.target.classList.contains('--active')) return;
        this.querySelector('product-tab.--active').classList.remove('--active');
        event.target.classList.add('--active');

        this.querySelector('product-tabcontent.--active').classList.remove('--active');
        const panelID = event.target.getAttribute('tab');
        this.querySelector(panelID).classList.add('--active');
    }
}

customElements.define('product-tabs', ProductTabs);
